import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import consumer from '../channels/consumer'
import debounced from 'debounced'

const application = Application.start()

const context = require.context("controllers", true, /_controller\.(js|ts)$/)
application.load(definitionsFromContext(context))
application.consumer = consumer

debounced.initialize({ input: { wait: 2500 } })
